import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createPassword } from "../../actions/userActions";
import Form from "./Form";
import { Grid, TextField } from "@material-ui/core";

class CreatePasswordForm extends Component {
  state = {
    password: "",
    passwordConfirmation: "",
  };

  createPassword = (e) => {
    e.preventDefault();

    this.props
      .createPassword(this.props.token, this.state)
      .then(() => (window.location.href = `/`));
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <Form
        onSubmit={this.createPassword}
        submitText="Wijzigen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="password"
              name="password"
              label="Wachtwoord *"
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id="passwordConfirmation"
              name="passwordConfirmation"
              label="Wachtwoord herhalen *"
              value={this.state.passwordConfirmation}
              onChange={this.handleChange}
              type="password"
              fullWidth
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

CreatePasswordForm.propTypes = {
  token: PropTypes.string.isRequired,
  createPassword: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.user.createPassword.successMessage,
  errorMessage: state.user.createPassword.errorMessage,
  isFetching: state.user.createPassword.isFetching,
});

export default connect(mapStateToProps, { createPassword })(CreatePasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/CreatePasswordForm.js